import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Text, List, ActionIcon, useMantineTheme } from "@mantine/core";
import { FiChevronRight } from "react-icons/fi";
import { AppContext } from "src/api/AppContext";
import { CLIENT_ROUTES } from "src/utils/constants";

const Groups = () => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { currentClient } = useContext(AppContext);
  let color = theme.colors.primaryTextColor[6];

  return (
    <Flex w={"100%"} direction={"column"} justify={"flex-start"}>
      <Text size={18} fw={500} color={theme.colors.secondaryTextColor[6]}>
        Groups
      </Text>
      <List
        my={10}
        styles={{
          itemWrapper: {
            width: "100%",
          },
          item: {
            listStyle: "none",
            background: theme.colors.primary[6],
            borderRadius: "10px",
            fontSize: 13,
            cursor: "pointer",
            color: theme.colors.primaryTextColor[6],
          },
        }}
      >
        {currentClient?.groups &&
          currentClient?.groups.map((group) => {
            return (
              <List.Item
                key={group.id}
                my={15}
                p={15}
                onClick={() => {
                  navigate(`/${CLIENT_ROUTES.GROUP_CLIENTS}/${group.id}`, {
                    state: {
                      groupName: group.name,
                      clients: group?.clients,
                    },
                  });
                }}
              >
                <Flex justify={"space-between"} align={"center"}>
                  <Flex direction={"column"}>
                    <Text fw={500} size={16}>
                      {group?.name}
                    </Text>
                    <Text size={14} fw={400}>
                      {group.clientGroupType}
                    </Text>
                  </Flex>
                  <Flex>
                    <ActionIcon size="lg">
                      <FiChevronRight color={color} />
                    </ActionIcon>
                  </Flex>
                </Flex>
              </List.Item>
            );
          })}
      </List>
    </Flex>
  );
};

export default Groups;
